/**
 * Íconos Lottie animados — premium, locales, sin CDN (por legislación: todo lo
 * servimos nosotros). Monta una animación Lottie (.json local) en un contenedor,
 * con FALLBACK a un SVG potente si Lottie no carga (nunca queda roto).
 *
 * El motor lottie-web (light) está en js/vendor/, las animaciones en
 * assets/lottie/. Carga perezosa: el motor solo se importa cuando de verdad se
 * monta un ícono (no pesa al boot si no se usa).
 */

let _lottiePromise = null;
function cargarMotor() {
    if (!_lottiePromise) {
        // Import dinámico del vendor local (Vite lo resuelve a un chunk aparte).
        _lottiePromise = import('../vendor/lottie-light.min.js')
            .then((m) => m.default || window.lottie || m)
            .catch(() => null);
    }
    return _lottiePromise;
}

/**
 * Monta un ícono Lottie en `contenedor`. Si el .json no carga o el motor falla,
 * pinta el `svgFallback` (un ícono potente estático) para no dejar hueco.
 * @param {HTMLElement} contenedor
 * @param {{ src:string, svgFallback:string, loop?:boolean, autoplay?:boolean }} opts
 * @returns {{ destroy:()=>void }}
 */
export function montarLottie(contenedor, { src, svgFallback, loop = true, autoplay = true }) {
    if (!contenedor) return { destroy() {} };
    // Pintar el fallback YA (se ve mientras carga el Lottie; si falla, queda este).
    contenedor.innerHTML = svgFallback || '';

    let anim = null;
    let vivo = true;

    (async () => {
        const lottie = await cargarMotor();
        if (!lottie || !vivo) return;
        let data = null;
        try {
            const resp = await fetch(src);
            if (!resp.ok) return; // queda el fallback
            data = await resp.json();
        } catch (_) {
            return; // queda el fallback
        }
        if (!vivo) return;
        contenedor.innerHTML = ''; // quitar el fallback, montar el Lottie
        try {
            anim = lottie.loadAnimation({
                container: contenedor,
                renderer: 'svg',
                loop,
                autoplay,
                animationData: data,
            });
            // Auto-cleanup: si el contenedor sale del DOM (cambio de vista), destruir
            // la animación para que lottie-web pare su requestAnimationFrame (evita
            // leak: un Lottio animando en background por cada visita a la vista).
            const watcher = setInterval(() => {
                if (!contenedor.isConnected) {
                    clearInterval(watcher);
                    vivo = false;
                    if (anim) {
                        try {
                            anim.destroy();
                        } catch (_) {}
                    }
                }
            }, 2000);
        } catch (_) {
            contenedor.innerHTML = svgFallback || '';
        }
    })();

    return {
        destroy() {
            vivo = false;
            if (anim) {
                try {
                    anim.destroy();
                } catch (_) {}
            }
        },
    };
}
